// // import React, { useState, useEffect, useRef } from "react";
// // import { useNavigate, useSearchParams } from "react-router-dom";
// // import "./Download.css";

// // const Download = () => {
// //   const [cartData, setCartData] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState("");
// //   const [downloadProgress, setDownloadProgress] = useState(0);
// //   const [downloadComplete, setDownloadComplete] = useState(false);
// //   const [isPlaying, setIsPlaying] = useState(false);
// //   const mediaRef = useRef(null);

// //   const navigate = useNavigate();
// //   const [searchParams] = useSearchParams();
// //   const cartId = searchParams.get("orderNo");

// //   const API_BASE_URL = "https://djv4.mediarocket.in/api/api";

// //   useEffect(() => {
// //     if (cartId) {
// //       fetchCartData(cartId);
// //     } else {
// //       setError("No cart ID provided in the URL");
// //       setLoading(false);
// //     }
// //   }, [cartId]);

// //   const fetchCartData = async (cartId) => {
// //     try {
// //       setLoading(true);
// //       const response = await fetch(`${API_BASE_URL}/cart/${cartId}/`);

// //       if (!response.ok) {
// //         throw new Error("Failed to fetch cart data");
// //       }

// //       const data = await response.json();
// //       setCartData(data);
// //       setLoading(false);
// //     } catch (err) {
// //       setError(err.message);
// //       setLoading(false);
// //     }
// //   };

// //   const togglePlay = () => {
// //     if (mediaRef.current) {
// //       if (isPlaying) {
// //         mediaRef.current.pause();
// //       } else {
// //         mediaRef.current.play();
// //       }
// //       setIsPlaying(!isPlaying);
// //     }
// //   };

// //   const handleDownload = () => {
// //     if (!cartData) return;

// //     const downloadUrl =
// //       cartData.product.music_file || cartData.product.video_file;
// //     if (!downloadUrl) {
// //       setError("No download available for this product");
// //       return;
// //     }

// //     // Create a fake progress simulation
// //     let progress = 0;
// //     const interval = setInterval(() => {
// //       progress += 5;
// //       setDownloadProgress(progress);

// //       if (progress >= 100) {
// //         clearInterval(interval);
// //         setDownloadComplete(true);

// //         // Start actual download
// //         const link = document.createElement("a");
// //         link.href = downloadUrl;
// //         link.setAttribute("download", "");
// //         document.body.appendChild(link);
// //         link.click();
// //         document.body.removeChild(link);

// //         // Redirect to home after 3 seconds
// //         setTimeout(() => {
// //           navigate("/");
// //         }, 3000);
// //       }
// //     }, 100);
// //   };

// //   if (loading) {
// //     return (
// //       <div className="download-container">
// //         <div className="download-content">
// //           <h2>Loading your download...</h2>
// //           <div className="loading-spinner"></div>
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return (
// //       <div className="download-container">
// //         <div className="download-content error">
// //           <h2>Error</h2>
// //           <p>{error}</p>
// //           <button onClick={() => navigate("/")}>Return to Home</button>
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (!cartData) {
// //     return (
// //       <div className="download-container">
// //         <div className="download-content error">
// //           <h2>No data found</h2>
// //           <p>We couldn't find any download associated with this link.</p>
// //           <button onClick={() => navigate("/")}>Return to Home</button>
// //         </div>
// //       </div>
// //     );
// //   }

// //   const isVideo = cartData.product.product_type === "video";
// //   const mediaUrl = cartData.product.video_file || cartData.product.music_file;

// //   return (
// //     <div className="download-container">
// //       <div className="download-content">
// //         <h1>Your Download</h1>

// //         <div className="product-info">
// //           <h2>{cartData.product.product_name}</h2>
// //           <p className="product-type">
// //             {cartData.product.product_type.toUpperCase()}
// //           </p>
// //           <p>
// //             <strong>Artist:</strong> {cartData.product.author_name}
// //           </p>
// //           <p>
// //             <strong>Category:</strong> {cartData.product.category_name}
// //           </p>
// //           <p>
// //             <strong>Subcategory:</strong> {cartData.product.subcategory_name}
// //           </p>

// //           {cartData.product.composer && (
// //             <p>
// //               <strong>Composer:</strong> {cartData.product.composer}
// //             </p>
// //           )}

// //           {cartData.product.lyricist && (
// //             <p>
// //               <strong>Lyricist:</strong> {cartData.product.lyricist}
// //             </p>
// //           )}

// //           {cartData.product.singer_name && (
// //             <p>
// //               <strong>Singer:</strong> {cartData.product.singer_name}
// //             </p>
// //           )}
// //         </div>

// //         {/* Media Player Section */}
// //         {mediaUrl && (
// //           <div className="media-player">
// //             <h3>Preview</h3>
// //             {isVideo ? (
// //               <video
// //                 ref={mediaRef}
// //                 src={mediaUrl}
// //                 controls
// //                 className="media-element"
// //                 onPlay={() => setIsPlaying(true)}
// //                 onPause={() => setIsPlaying(false)}
// //               />
// //             ) : (
// //               <div className="audio-player">
// //                 <audio
// //                   ref={mediaRef}
// //                   src={mediaUrl}
// //                   controls
// //                   className="media-element"
// //                   onPlay={() => setIsPlaying(true)}
// //                   onPause={() => setIsPlaying(false)}
// //                 />
// //                 <div className="audio-controls">
// //                   <button onClick={togglePlay} className="play-pause-btn">
// //                     {isPlaying ? "Pause" : "Play"}
// //                   </button>
// //                 </div>
// //               </div>
// //             )}
// //           </div>
// //         )}

// //         {!downloadComplete ? (
// //           <div className="download-section">
// //             {downloadProgress > 0 ? (
// //               <div className="progress-container">
// //                 <div className="progress-bar">
// //                   <div
// //                     className="progress-fill"
// //                     style={{ width: `${downloadProgress}%` }}
// //                   ></div>
// //                 </div>
// //                 <p>Preparing your download... {downloadProgress}%</p>
// //               </div>
// //             ) : (
// //               <button className="download-btn" onClick={handleDownload}>
// //                 Download Now
// //               </button>
// //             )}
// //           </div>
// //         ) : (
// //           <div className="download-complete">
// //             <div className="success-animation">
// //               <svg
// //                 className="checkmark"
// //                 xmlns="http://www.w3.org/2000/svg"
// //                 viewBox="0 0 52 52"
// //               >
// //                 <circle
// //                   className="checkmark__circle"
// //                   cx="26"
// //                   cy="26"
// //                   r="25"
// //                   fill="none"
// //                 />
// //                 <path
// //                   className="checkmark__check"
// //                   fill="none"
// //                   d="M14.1 27.2l7.1 7.2 16.7-16.8"
// //                 />
// //               </svg>
// //             </div>
// //             <h3>Download Complete!</h3>
// //             <p>Redirecting you to the home page in a few seconds...</p>
// //           </div>
// //         )}

// //         <div className="customer-info">
// //           <p>This download was requested by {cartData.email}</p>
// //           <p>
// //             Requested on: {new Date(cartData.added_at).toLocaleDateString()}
// //           </p>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default Download;
// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, useSearchParams } from "react-router-dom";
// import "./Download.css";

// const Download = () => {
//   const [cartData, setCartData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [downloadProgress, setDownloadProgress] = useState(0);
//   const [downloadComplete, setDownloadComplete] = useState(false);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const mediaRef = useRef(null);

//   const navigate = useNavigate();
//   const [searchParams] = useSearchParams();
//   const cartId = searchParams.get("orderNo");

//   const API_BASE_URL = "https://djv4.mediarocket.in/api/api";

//   useEffect(() => {
//     if (cartId) {
//       fetchCartData(cartId);
//     } else {
//       setError("No cart ID provided in the URL");
//       setLoading(false);
//     }
//   }, [cartId]);

//   const fetchCartData = async (cartId) => {
//     try {
//       setLoading(true);
//       const response = await fetch(`${API_BASE_URL}/cart/${cartId}/`);

//       if (!response.ok) {
//         throw new Error("Failed to fetch cart data");
//       }

//       const data = await response.json();
//       setCartData(data);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const togglePlay = () => {
//     if (mediaRef.current) {
//       if (isPlaying) {
//         mediaRef.current.pause();
//       } else {
//         mediaRef.current.play();
//       }
//       setIsPlaying(!isPlaying);
//     }
//   };

//   const handleDownload = async () => {
//     if (!cartData) return;

//     const downloadUrl =
//       cartData.product.music_file || cartData.product.video_file;
//     if (!downloadUrl) {
//       setError("No download available for this product");
//       return;
//     }

//     try {
//       // Create a fake progress simulation
//       let progress = 0;
//       const interval = setInterval(() => {
//         progress += 5;
//         setDownloadProgress(progress);

//         if (progress >= 100) {
//           clearInterval(interval);
//           setDownloadComplete(true);

//           // Start actual download
//           const link = document.createElement("a");
//           link.href = downloadUrl;
//           link.setAttribute("download", "");
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);

//           // Redirect to home after 3 seconds
//           setTimeout(() => {
//             navigate("/");
//           }, 3000);
//         }
//       }, 100);
//     } catch (err) {
//       setError("Failed to download the file");
//       console.error("Download error:", err);
//     }
//   };

//   if (loading) {
//     return (
//       <div className="download-container">
//         <div className="download-content">
//           <h2>Loading your download...</h2>
//           <div className="loading-spinner"></div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="download-container">
//         <div className="download-content error">
//           <h2>Error</h2>
//           <p>{error}</p>
//           <button onClick={() => navigate("/")}>Return to Home</button>
//         </div>
//       </div>
//     );
//   }

//   if (!cartData) {
//     return (
//       <div className="download-container">
//         <div className="download-content error">
//           <h2>No data found</h2>
//           <p>We couldn't find any download associated with this link.</p>
//           <button onClick={() => navigate("/")}>Return to Home</button>
//         </div>
//       </div>
//     );
//   }

//   const isVideo = cartData.product.product_type === "video";
//   const mediaUrl = cartData.product.video_file || cartData.product.music_file;

//   return (
//     <div className="download-container">
//       <div className="download-content">
//         <h1>Your Download</h1>

//         <div className="product-info">
//           <h2>{cartData.product.product_name}</h2>
//           <p className="product-type">
//             {cartData.product.product_type.toUpperCase()}
//           </p>
//           <p>
//             <strong>Artist:</strong> {cartData.product.author_name}
//           </p>
//           <p>
//             <strong>Category:</strong> {cartData.product.category_name}
//           </p>
//           <p>
//             <strong>Subcategory:</strong> {cartData.product.subcategory_name}
//           </p>

//           {cartData.product.composer && (
//             <p>
//               <strong>Composer:</strong> {cartData.product.composer}
//             </p>
//           )}

//           {cartData.product.lyricist && (
//             <p>
//               <strong>Lyricist:</strong> {cartData.product.lyricist}
//             </p>
//           )}

//           {cartData.product.singer_name && (
//             <p>
//               <strong>Singer:</strong> {cartData.product.singer_name}
//             </p>
//           )}
//         </div>

//         {/* Media Player Section */}
//         {mediaUrl && (
//           <div className="media-player">
//             <h3>Preview</h3>
//             {isVideo ? (
//               <video
//                 ref={mediaRef}
//                 src={mediaUrl}
//                 controls
//                 className="media-element"
//                 onPlay={() => setIsPlaying(true)}
//                 onPause={() => setIsPlaying(false)}
//               />
//             ) : (
//               <div className="audio-player">
//                 <audio
//                   ref={mediaRef}
//                   src={mediaUrl}
//                   controls
//                   className="media-element"
//                   onPlay={() => setIsPlaying(true)}
//                   onPause={() => setIsPlaying(false)}
//                 />
//                 <div className="audio-controls">
//                   <button onClick={togglePlay} className="play-pause-btn">
//                     {isPlaying ? "Pause" : "Play"}
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {!downloadComplete ? (
//           <div className="download-section">
//             {downloadProgress > 0 ? (
//               <div className="progress-container">
//                 <div className="progress-bar">
//                   <div
//                     className="progress-fill"
//                     style={{ width: `${downloadProgress}%` }}
//                   ></div>
//                 </div>
//                 <p>Preparing your download... {downloadProgress}%</p>
//               </div>
//             ) : (
//               <button className="download-btn" onClick={handleDownload}>
//                 Download Now
//               </button>
//             )}
//           </div>
//         ) : (
//           <div className="download-complete">
//             <div className="success-animation">
//               <svg
//                 className="checkmark"
//                 xmlns="http://www.w3.org/2000/svg"
//                 viewBox="0 0 52 52"
//               >
//                 <circle
//                   className="checkmark__circle"
//                   cx="26"
//                   cy="26"
//                   r="25"
//                   fill="none"
//                 />
//                 <path
//                   className="checkmark__check"
//                   fill="none"
//                   d="M14.1 27.2l7.1 7.2 16.7-16.8"
//                 />
//               </svg>
//             </div>
//             <h3>Download Complete!</h3>
//             <p>Redirecting you to the home page in a few seconds...</p>
//           </div>
//         )}

//         <div className="customer-info">
//           <p>This download was requested by {cartData.email}</p>
//           <p>
//             Requested on: {new Date(cartData.added_at).toLocaleDateString()}
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Download;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./Download.css";

const Download = () => {
  const [cartData, setCartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [downloadComplete, setDownloadComplete] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const mediaRef = useRef(null);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cartId = searchParams.get("orderNo");

  const API_BASE_URL = "https://djv4.mediarocket.in/api/api";

  useEffect(() => {
    if (cartId) {
      fetchCartData(cartId);
    } else {
      setError("No order number provided in the URL");
      setLoading(false);
    }
  }, [cartId]);

  const fetchCartData = async (cartId) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_BASE_URL}/cart/${cartId}/`);

      if (!response.ok) {
        throw new Error("Failed to fetch order data");
      }

      const data = await response.json();
      setCartData(data);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const togglePlay = () => {
    if (mediaRef.current) {
      if (isPlaying) {
        mediaRef.current.pause();
      } else {
        mediaRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleDownload = async () => {
    if (!cartData) return;

    const downloadUrl =
      cartData.product.music_file || cartData.product.video_file;
    if (!downloadUrl) {
      setError("No download available for this product");
      return;
    }

    try {
      // Create a fake progress simulation
      let progress = 0;
      const interval = setInterval(() => {
        progress += 5;
        setDownloadProgress(progress);

        if (progress >= 100) {
          clearInterval(interval);
          setDownloadComplete(true);

          // Start actual download
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // Redirect to home after 3 seconds
          setTimeout(() => {
            navigate("/");
          }, 3000);
        }
      }, 100);
    } catch (err) {
      setError("Failed to download the file");
      console.error("Download error:", err);
    }
  };

  if (loading) {
    return (
      <div className="download-container">
        <div className="download-content">
          <div className="loading-header">
            <h1>Preparing Your Download</h1>
            <p>Please wait while we retrieve your content...</p>
          </div>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="download-container">
        <div className="download-content error">
          <div className="error-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="64"
              height="64"
            >
              <path
                fill="#e94560"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              />
            </svg>
          </div>
          <h2>Oops! Something went wrong</h2>
          <p>{error}</p>
          <button className="return-home-btn" onClick={() => navigate("/")}>
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  if (!cartData) {
    return (
      <div className="download-container">
        <div className="download-content error">
          <div className="error-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="64"
              height="64"
            >
              <path
                fill="#e94560"
                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
              />
            </svg>
          </div>
          <h2>Download Not Found</h2>
          <p>We couldn't find any download associated with this link.</p>
          <button className="return-home-btn" onClick={() => navigate("/")}>
            Return to Home
          </button>
        </div>
      </div>
    );
  }

  const isVideo = cartData.product.product_type === "video";
  const mediaUrl = cartData.product.video_file || cartData.product.music_file;

  return (
    <div className="download-container">
      <div className="download-content">
        <div className="download-header">
          <h1>Your Download is Ready!</h1>
          <p>Thank you for your purchase</p>
        </div>

        <div className="product-card">
          <div className="product-header">
            <h2>{cartData.product.product_name}</h2>
            <span className={`product-type ${isVideo ? "video" : "audio"}`}>
              {cartData.product.product_type.toUpperCase()}
            </span>
          </div>

          <div className="product-details">
            <div className="detail-row">
              <span className="detail-label">Artist:</span>
              <span className="detail-value">
                {cartData.product.author_name}
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Category:</span>
              <span className="detail-value">
                {cartData.product.category_name}
              </span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Subcategory:</span>
              <span className="detail-value">
                {cartData.product.subcategory_name}
              </span>
            </div>

            {cartData.product.composer && (
              <div className="detail-row">
                <span className="detail-label">Composer:</span>
                <span className="detail-value">
                  {cartData.product.composer}
                </span>
              </div>
            )}

            {cartData.product.lyricist && (
              <div className="detail-row">
                <span className="detail-label">Lyricist:</span>
                <span className="detail-value">
                  {cartData.product.lyricist}
                </span>
              </div>
            )}

            {cartData.product.singer_name && (
              <div className="detail-row">
                <span className="detail-label">Singer:</span>
                <span className="detail-value">
                  {cartData.product.singer_name}
                </span>
              </div>
            )}
          </div>
        </div>

        {/* Media Player Section */}
        {mediaUrl && (
          <div className="media-player-card">
            <h3>Preview</h3>
            {isVideo ? (
              <div className="video-container">
                <video
                  ref={mediaRef}
                  src={mediaUrl}
                  controls
                  className="media-element"
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                />
              </div>
            ) : (
              <div className="audio-player">
                <div className="audio-controls">
                  <button onClick={togglePlay} className="play-pause-btn">
                    {isPlaying ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    )}
                    <span>{isPlaying ? "Pause" : "Play"}</span>
                  </button>
                </div>
                <audio
                  ref={mediaRef}
                  src={mediaUrl}
                  onPlay={() => setIsPlaying(true)}
                  onPause={() => setIsPlaying(false)}
                />
                <div className="audio-visualizer">
                  <div className="visualizer-bar"></div>
                  <div className="visualizer-bar"></div>
                  <div className="visualizer-bar"></div>
                  <div className="visualizer-bar"></div>
                  <div className="visualizer-bar"></div>
                </div>
              </div>
            )}
          </div>
        )}

        {!downloadComplete ? (
          <div className="download-section">
            {downloadProgress > 0 ? (
              <div className="progress-container">
                <div className="progress-info">
                  <span>Preparing your download...</span>
                  <span>{downloadProgress}%</span>
                </div>
                <div className="progress-bar">
                  <div
                    className="progress-fill"
                    style={{ width: `${downloadProgress}%` }}
                  ></div>
                </div>
              </div>
            ) : (
              <button className="download-btn" onClick={handleDownload}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
                </svg>
                Download Now
              </button>
            )}
          </div>
        ) : (
          <div className="download-complete">
            <div className="success-animation">
              <svg
                className="checkmark"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 52"
              >
                <circle
                  className="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  className="checkmark__check"
                  fill="none"
                  d="M14.1 27.2l7.1 7.2 16.7-16.8"
                />
              </svg>
            </div>
            <h3>Download Complete!</h3>
            <p>Your file has been downloaded successfully.</p>
            <div className="countdown">
              <p>
                Redirecting to home page in <span>3</span> seconds...
              </p>
            </div>
          </div>
        )}

        <div className="customer-info">
          <div className="customer-detail">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
            </svg>
            <span>Download requested by: {cartData.email}</span>
          </div>
          <div className="customer-detail">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
            </svg>
            <span>
              Requested on: {new Date(cartData.added_at).toLocaleDateString()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Download;
